<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora de Lucro</h5>
        <div class="row">
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow">
              <label>Valor apostado</label>
            </div>
            <input type="text" v-model="betValue" v-on:keyup="verifyBetValue(betValue)" class="form-control input-format-grey" placeholder="$100,00" style="padding-left:200px;">
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow">
              <label>Odd da aposta</label>
            </div>
            <money
              v-model="oddValue"
              :keyup="verifyOddValue(oddValue)"
              v-bind="odd"
              class="form-control input-format-grey"
              style="padding-left:200px;"
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-green">
              <label class="text-white">Lucro previsto</label>
            </div>
            <money
              v-model="moneyReturn"
              v-bind="money"
              class="form-control input-format-green"
              placeholder="R$ 90,00"
              style="padding-left:200px;"
            />
          </div>

          <div class="col-12 mt-3">
            <div class="clubedaaposta">
              <label>clubedaposta.com</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'ProfitCalculator',
  components: {
    Money,
  },
  data () {
    return {
      betValue: 100,
      oddValue: 1.80,
      moneyReturn: 'R$ 80,00',
      odd: {
        decimal: '.',
        prefix: '@',
        suffix: '',
        precision: 2,
        masked: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    verifyBetValue(item) {
      this.betValue = item;
      this.moneyReturn = (this.betValue * this.oddValue - this.betValue)
    },
    verifyOddValue(item) {
      this.oddValue = item;
      this.moneyReturn = (this.betValue * this.oddValue - this.betValue)
    },
  }
}
</script>
